import { useEffect } from 'react'

import { useUser } from '../../../utilities/hooks/useUser'
import { actions as rawActions } from '../state/bank-users-slice'
import { useAppSelector } from '../store/hooks'
import { useActions } from '../store/use-actions'
import BankUsersLayout from '../templates/bank-users-layout'

export const BankUsersWithState = () => {
  const { data: user } = useUser()
  const state = useAppSelector(state => state.bankUsers)
  const actions = useActions(rawActions)
  useEffect(() => {
    actions.init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BankUsersLayout
      availableRoles={state.availableRoles}
      canDelete={state.canDelete}
      canProceed={state.canProceed}
      currentUser={user.userName}
      errors={state.errors}
      isFiltering={state.isFiltering}
      isNew={state.isNew}
      roleFilter={state.roleFilter}
      saveSuccess={state.saveSuccess}
      searchTerm={state.searchTerm}
      selectedUser={state.selectedUser}
      serverErrors={state.serverErrors}
      setIsNew={() => actions.setNewUser()}
      totalNumUsers={state.numTotalUsers}
      users={state.filteredUsers}
      verificationUsername={state.verificationUsername}
      onChangeEmail={x => actions.setEmail(x)}
      onChangeFirstName={x => actions.setFirstName(x)}
      onChangeLastName={x => actions.setLastName(x)}
      onChangeRole={x => actions.setRole(x)}
      onChangeRoleFilter={x => actions.setRoleFilter(x)}
      onChangeSearchTerm={x => actions.setSearchTerm(x)}
      onChangeVerificationUser={(input, target) =>
        actions.setVerificationUsername({ input, target })
      }
      onClickFilter={() => actions.setFilteringState()}
      onDeleteUser={() => actions.deleteUser()}
      onSaveUser={() => actions.saveUser()}
      onSelectUser={id => actions.setSelectedUser(id)}
    />
  )
}
